import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Button from '@mui/material/Button'
import Notifications from '@mui/icons-material/Notifications'
import Typography from '@mui/material/Typography'
import { CSSTransition } from 'react-transition-group'

import { temUnidadesAtuaisSelecionadas } from '../../controllers/unidadesController'
import { recuperarAlertas } from '../../actions/alertasActions'
import styles from './MenuAlertas.module.css'

import './MenuAlertasStyles.css'

export class MenuAlertas extends Component {
  constructor(props) {
    super(props)
    this.state = {
      alertasUpdated: false
    }
    this.handleNotificacoesButtonClick = this.handleNotificacoesButtonClick.bind(this)
  }

  componentDidMount() {
    const {
      filtros: { unidadesAtuais }
    } = this.props
    if (temUnidadesAtuaisSelecionadas(unidadesAtuais)) {
      this.props.recuperarAlertas()
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      alertas: { qtdeAlertas, qtdeAlertasNaoLidas }
    } = this.props
    const {
      alertas: { qtdeAlertas: prevQtdeAlertas }
    } = prevProps
    const { alertasUpdated } = this.state
    const { path } = this.props.match
    if (
      qtdeAlertasNaoLidas &&
      qtdeAlertas !== prevQtdeAlertas &&
      !alertasUpdated &&
      path !== '/alertas'
    ) {
      this.handleAlertasUpdated()
    }
  }

  handleAlertasUpdated() {
    this.setState({ alertasUpdated: true })
  }

  handleNotificacoesButtonClick() {
    const { history } = this.props
    this.setState({ alertasUpdated: false })
    history.push('/alertas')
  }

  render() {
    const {
      alertas: { qtdeAlertasNaoLidas }
    } = this.props
    const { alertasUpdated } = this.state
    return (
      <Button
        color='secondary'
        id='button-abrir-notificacoes'
        style={{
          backgroundColor: alertasUpdated ? '#f85858' : '#fff',
          color: alertasUpdated ? '#fff' : '#000',
          padding: '8px 16px 8px 14px',
          borderRadius: '32px',
          boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.25)'
        }}
        onClick={this.handleNotificacoesButtonClick}>
        <CSSTransition appear in={alertasUpdated} timeout={5000} classNames='notifications-icon'>
          <Notifications
            className={
              alertasUpdated ? styles.notificationIconComAlerta : styles.notificationIconSemAlerta
            }
          />
        </CSSTransition>
        <Typography
          variant='subtitle2'
          className={
            alertasUpdated ? styles.textoNotificacaoComAlerta : styles.textoNotificacaoSemAlerta
          }>
          Notificações ({qtdeAlertasNaoLidas})
        </Typography>
      </Button>
    )
  }
}

const mapStateToProps = ({ alertas, filtros }) => ({ alertas, filtros })

const reduxEnhanced = connect(mapStateToProps, { recuperarAlertas })(MenuAlertas)

export default withRouter(reduxEnhanced)
